import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoginComponent } from "./components/login/login.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { AuthComponent, AuthBlockComponent } from "./components";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule.forRoot(), FormsModule, ReactiveFormsModule],
  declarations: [AuthComponent, LoginComponent, LogoutComponent, AuthBlockComponent],
})
export class AuthModule {}
